import { createLoader, useMutation } from '@meteor/data-hooks';
import { withAuth } from '../../user';
import { agentClient } from '../client';

export let currentFlowLoader = createLoader({
  name: 'current_flow',
  hash: i => i.agentId + i.instanceId + i.flowId,
  fetch: (i: { instanceId: string; agentId: string; flowId?: string }) =>
    withAuth(() => agentClient.flow.getCurrent(i)),
  mutators: {}
});

export let useCurrentFlow = (
  instanceId: string | null | undefined,
  agentId: string | null | undefined,
  flowId?: string | null | undefined
) => {
  return currentFlowLoader.use(
    instanceId && agentId && flowId !== null ? { instanceId, agentId, flowId } : null
  );
};

export let usePublishFlow = () => {
  return useMutation(agentClient.flow.publish);
};
